// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"310":"d07f0714","680":"cf65a552","813":"04d58c1a"}[chunkId] + ".chunk.js";
};